import { render } from "./ViewMercadoPending.vue?vue&type=template&id=1bda1932"
import script from "./ViewMercadoPending.vue?vue&type=script&lang=js"
export * from "./ViewMercadoPending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__